import { render } from "./companyMaterials.vue?vue&type=template&id=31619ae2&ts=true"
import script from "./companyMaterials.vue?vue&type=script&lang=ts"
export * from "./companyMaterials.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__